/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessScope,
  CodeSent,
  Connection,
  ConsentsUpdate,
  EmailCodeRequest,
  EmailCodeVerify,
  ErrorEnvelope,
  GoogleAuthorization,
  GoogleComplete,
  GoogleStart,
  Me,
  MeUpdate,
  OAuthApproval,
  OAuthRedirect,
  OAuthRequestView,
  SignedIn,
  TermsAccept,
  Token,
  TokenCreate,
  TokenCreated
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetMeUrl = () => {




  return `/api/v1/me`
}

/**
 * The signed-in user.
 * @summary Get Me
 */
export const getMe = async ( options?: Parameters<typeof apiRequest>[1]): Promise<Me> => {

  return apiRequest<Me>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/v1/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ErrorEnvelope>


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Me
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateMeUrl = () => {




  return `/api/v1/me`
}

/**
 * Change the display name. Browser sessions only.
 * @summary Update Me
 */
export const updateMe = async (meUpdate: MeUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<Me> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Me>(getUpdateMeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(meUpdate)
  }
);}





export const getUpdateMeMutationKey = () => ['updateMe'] as const;

export const getUpdateMeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,UpdateMeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,UpdateMeMutationVariables, TContext> => {

const mutationKey = getUpdateMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMe>>, UpdateMeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateMe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMe>>>
    export type UpdateMeMutationBody = MeUpdate
    export type UpdateMeMutationError = ErrorType<ErrorEnvelope>
    export type UpdateMeMutationVariables = {data: MeUpdate}

    /**
 * @summary Update Me
 */
export const useUpdateMe = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,UpdateMeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMe>>,
        TError,
        UpdateMeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMeMutationOptions(options), queryClient);
    }
    export const getGetAccessScopeUrl = () => {




  return `/api/v1/me/access-scope`
}

/**
 * The actor's teams with their role and brand ids: the one source for the SPA's gates.
 * @summary Get Access Scope
 */
export const getAccessScope = async ( options?: Parameters<typeof apiRequest>[1]): Promise<AccessScope> => {

  return apiRequest<AccessScope>(getGetAccessScopeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccessScopeQueryKey = () => {
    return [
    `/api/v1/me/access-scope`
    ] as const;
    }


export const getGetAccessScopeQueryOptions = <TData = Awaited<ReturnType<typeof getAccessScope>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessScope>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessScopeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessScope>>> = ({ signal }) => getAccessScope({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessScope>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessScopeQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessScope>>>
export type GetAccessScopeQueryError = ErrorType<ErrorEnvelope>


export function useGetAccessScope<TData = Awaited<ReturnType<typeof getAccessScope>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessScope>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessScope>>,
          TError,
          Awaited<ReturnType<typeof getAccessScope>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessScope<TData = Awaited<ReturnType<typeof getAccessScope>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessScope>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessScope>>,
          TError,
          Awaited<ReturnType<typeof getAccessScope>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessScope<TData = Awaited<ReturnType<typeof getAccessScope>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessScope>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Access Scope
 */

export function useGetAccessScope<TData = Awaited<ReturnType<typeof getAccessScope>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessScope>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessScopeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListConnectionsUrl = () => {




  return `/api/v1/me/connections`
}

/**
 * The MCP clients the user connected by OAuth, in every team. Browser sessions only.
 * @summary List Connections
 */
export const listConnections = async ( options?: Parameters<typeof apiRequest>[1]): Promise<Connection[]> => {

  return apiRequest<Connection[]>(getListConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConnectionsQueryKey = () => {
    return [
    `/api/v1/me/connections`
    ] as const;
    }


export const getListConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnections>>> = ({ signal }) => listConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listConnections>>>
export type ListConnectionsQueryError = ErrorType<ErrorEnvelope>


export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Connections
 */

export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConnectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRevokeConnectionUrl = (connectionId: string,) => {




  return `/api/v1/me/connections/${connectionId}`
}

/**
 * End one connection: every token of it answers 401 on its next request.
 * @summary Revoke Connection
 */
export const revokeConnection = async (connectionId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getRevokeConnectionUrl(connectionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeConnectionMutationKey = () => ['revokeConnection'] as const;

export const getRevokeConnectionMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeConnection>>, TError,RevokeConnectionMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeConnection>>, TError,RevokeConnectionMutationVariables, TContext> => {

const mutationKey = getRevokeConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeConnection>>, RevokeConnectionMutationVariables> = (props) => {
          const {connectionId} = props ?? {};

          return  revokeConnection(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof revokeConnection>>>

    export type RevokeConnectionMutationError = ErrorType<ErrorEnvelope>
    export type RevokeConnectionMutationVariables = {connectionId: string}

    /**
 * @summary Revoke Connection
 */
export const useRevokeConnection = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeConnection>>, TError,RevokeConnectionMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeConnection>>,
        TError,
        RevokeConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeConnectionMutationOptions(options), queryClient);
    }
    export const getSetMyConsentsUrl = () => {




  return `/api/v1/me/consents`
}

/**
 * Give or withdraw marketing and ads consent. Browser sessions only.
 * @summary Set My Consents
 */
export const setMyConsents = async (consentsUpdate: ConsentsUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<Me> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Me>(getSetMyConsentsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(consentsUpdate)
  }
);}





export const getSetMyConsentsMutationKey = () => ['setMyConsents'] as const;

export const getSetMyConsentsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyConsents>>, TError,SetMyConsentsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof setMyConsents>>, TError,SetMyConsentsMutationVariables, TContext> => {

const mutationKey = getSetMyConsentsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMyConsents>>, SetMyConsentsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setMyConsents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMyConsentsMutationResult = NonNullable<Awaited<ReturnType<typeof setMyConsents>>>
    export type SetMyConsentsMutationBody = ConsentsUpdate
    export type SetMyConsentsMutationError = ErrorType<ErrorEnvelope>
    export type SetMyConsentsMutationVariables = {data: ConsentsUpdate}

    /**
 * @summary Set My Consents
 */
export const useSetMyConsents = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyConsents>>, TError,SetMyConsentsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setMyConsents>>,
        TError,
        SetMyConsentsMutationVariables,
        TContext
      > => {
      return useMutation(getSetMyConsentsMutationOptions(options), queryClient);
    }
    export const getGetOauthRequestUrl = (requestId: string,) => {




  return `/api/v1/me/oauth-requests/${requestId}`
}

/**
 * A pending MCP client's request for its consent page: a browser session's, with the
 * request's cookie, else 404.
 * @summary Get Oauth Request
 */
export const getOauthRequest = async (requestId: string, options?: Parameters<typeof apiRequest>[1]): Promise<OAuthRequestView> => {

  return apiRequest<OAuthRequestView>(getGetOauthRequestUrl(requestId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOauthRequestQueryKey = (requestId: string,) => {
    return [
    `/api/v1/me/oauth-requests/${requestId}`
    ] as const;
    }


export const getGetOauthRequestQueryOptions = <TData = Awaited<ReturnType<typeof getOauthRequest>>, TError = ErrorType<ErrorEnvelope>>(requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOauthRequest>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOauthRequestQueryKey(requestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOauthRequest>>> = ({ signal }) => getOauthRequest(requestId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: requestId !== null && requestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOauthRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOauthRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getOauthRequest>>>
export type GetOauthRequestQueryError = ErrorType<ErrorEnvelope>


export function useGetOauthRequest<TData = Awaited<ReturnType<typeof getOauthRequest>>, TError = ErrorType<ErrorEnvelope>>(
 requestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOauthRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOauthRequest>>,
          TError,
          Awaited<ReturnType<typeof getOauthRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOauthRequest<TData = Awaited<ReturnType<typeof getOauthRequest>>, TError = ErrorType<ErrorEnvelope>>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOauthRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOauthRequest>>,
          TError,
          Awaited<ReturnType<typeof getOauthRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOauthRequest<TData = Awaited<ReturnType<typeof getOauthRequest>>, TError = ErrorType<ErrorEnvelope>>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOauthRequest>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Oauth Request
 */

export function useGetOauthRequest<TData = Awaited<ReturnType<typeof getOauthRequest>>, TError = ErrorType<ErrorEnvelope>>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOauthRequest>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOauthRequestQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDenyOauthRequestUrl = (requestId: string,) => {




  return `/api/v1/me/oauth-requests/${requestId}/deny`
}

/**
 * The person declines: the request ends, and the client hears `access_denied`.
 * @summary Deny Oauth Request
 */
export const denyOauthRequest = async (requestId: string, options?: Parameters<typeof apiRequest>[1]): Promise<OAuthRedirect> => {

  return apiRequest<OAuthRedirect>(getDenyOauthRequestUrl(requestId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDenyOauthRequestMutationKey = () => ['denyOauthRequest'] as const;

export const getDenyOauthRequestMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyOauthRequest>>, TError,DenyOauthRequestMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof denyOauthRequest>>, TError,DenyOauthRequestMutationVariables, TContext> => {

const mutationKey = getDenyOauthRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof denyOauthRequest>>, DenyOauthRequestMutationVariables> = (props) => {
          const {requestId} = props ?? {};

          return  denyOauthRequest(requestId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DenyOauthRequestMutationResult = NonNullable<Awaited<ReturnType<typeof denyOauthRequest>>>

    export type DenyOauthRequestMutationError = ErrorType<ErrorEnvelope>
    export type DenyOauthRequestMutationVariables = {requestId: string}

    /**
 * @summary Deny Oauth Request
 */
export const useDenyOauthRequest = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyOauthRequest>>, TError,DenyOauthRequestMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof denyOauthRequest>>,
        TError,
        DenyOauthRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDenyOauthRequestMutationOptions(options), queryClient);
    }
    export const getRequestSignInCodeUrl = () => {




  return `/api/v1/me/sign-in/email`
}

/**
 * Email a 6-digit code. The answer is the same whether or not the email has an account:
 * 202, or 503 `EMAIL_UNAVAILABLE` for every address while the email provider is busy or
 * down.
 * @summary Request Sign In Code
 */
export const requestSignInCode = async (emailCodeRequest: EmailCodeRequest, options?: Parameters<typeof apiRequest>[1]): Promise<CodeSent> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CodeSent>(getRequestSignInCodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(emailCodeRequest)
  }
);}





export const getRequestSignInCodeMutationKey = () => ['requestSignInCode'] as const;

export const getRequestSignInCodeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSignInCode>>, TError,RequestSignInCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof requestSignInCode>>, TError,RequestSignInCodeMutationVariables, TContext> => {

const mutationKey = getRequestSignInCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestSignInCode>>, RequestSignInCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestSignInCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestSignInCodeMutationResult = NonNullable<Awaited<ReturnType<typeof requestSignInCode>>>
    export type RequestSignInCodeMutationBody = EmailCodeRequest
    export type RequestSignInCodeMutationError = ErrorType<ErrorEnvelope>
    export type RequestSignInCodeMutationVariables = {data: EmailCodeRequest}

    /**
 * @summary Request Sign In Code
 */
export const useRequestSignInCode = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSignInCode>>, TError,RequestSignInCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestSignInCode>>,
        TError,
        RequestSignInCodeMutationVariables,
        TContext
      > => {
      return useMutation(getRequestSignInCodeMutationOptions(options), queryClient);
    }
    export const getVerifySignInCodeUrl = () => {




  return `/api/v1/me/sign-in/email/verify`
}

/**
 * Sign in with the code: one session, in the cookie.
 * @summary Verify Sign In Code
 */
export const verifySignInCode = async (emailCodeVerify: EmailCodeVerify, options?: Parameters<typeof apiRequest>[1]): Promise<SignedIn> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<SignedIn>(getVerifySignInCodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(emailCodeVerify)
  }
);}





export const getVerifySignInCodeMutationKey = () => ['verifySignInCode'] as const;

export const getVerifySignInCodeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifySignInCode>>, TError,VerifySignInCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof verifySignInCode>>, TError,VerifySignInCodeMutationVariables, TContext> => {

const mutationKey = getVerifySignInCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifySignInCode>>, VerifySignInCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  verifySignInCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifySignInCodeMutationResult = NonNullable<Awaited<ReturnType<typeof verifySignInCode>>>
    export type VerifySignInCodeMutationBody = EmailCodeVerify
    export type VerifySignInCodeMutationError = ErrorType<ErrorEnvelope>
    export type VerifySignInCodeMutationVariables = {data: EmailCodeVerify}

    /**
 * @summary Verify Sign In Code
 */
export const useVerifySignInCode = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifySignInCode>>, TError,VerifySignInCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifySignInCode>>,
        TError,
        VerifySignInCodeMutationVariables,
        TContext
      > => {
      return useMutation(getVerifySignInCodeMutationOptions(options), queryClient);
    }
    export const getStartGoogleSignInUrl = () => {




  return `/api/v1/me/sign-in/google`
}

/**
 * Where to send the browser for Google; the attempt waits in a cookie.
 * @summary Start Google Sign In
 */
export const startGoogleSignIn = async (googleStart: GoogleStart, options?: Parameters<typeof apiRequest>[1]): Promise<GoogleAuthorization> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GoogleAuthorization>(getStartGoogleSignInUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(googleStart)
  }
);}





export const getStartGoogleSignInMutationKey = () => ['startGoogleSignIn'] as const;

export const getStartGoogleSignInMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startGoogleSignIn>>, TError,StartGoogleSignInMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startGoogleSignIn>>, TError,StartGoogleSignInMutationVariables, TContext> => {

const mutationKey = getStartGoogleSignInMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startGoogleSignIn>>, StartGoogleSignInMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startGoogleSignIn(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartGoogleSignInMutationResult = NonNullable<Awaited<ReturnType<typeof startGoogleSignIn>>>
    export type StartGoogleSignInMutationBody = GoogleStart
    export type StartGoogleSignInMutationError = ErrorType<ErrorEnvelope>
    export type StartGoogleSignInMutationVariables = {data: GoogleStart}

    /**
 * @summary Start Google Sign In
 */
export const useStartGoogleSignIn = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startGoogleSignIn>>, TError,StartGoogleSignInMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startGoogleSignIn>>,
        TError,
        StartGoogleSignInMutationVariables,
        TContext
      > => {
      return useMutation(getStartGoogleSignInMutationOptions(options), queryClient);
    }
    export const getCompleteGoogleSignInUrl = () => {




  return `/api/v1/me/sign-in/google/complete`
}

/**
 * Finish Google sign-in with what Google sent back to `/sign-in/google`.
 * @summary Complete Google Sign In
 */
export const completeGoogleSignIn = async (googleComplete: GoogleComplete, options?: Parameters<typeof apiRequest>[1]): Promise<SignedIn> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<SignedIn>(getCompleteGoogleSignInUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(googleComplete)
  }
);}





export const getCompleteGoogleSignInMutationKey = () => ['completeGoogleSignIn'] as const;

export const getCompleteGoogleSignInMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeGoogleSignIn>>, TError,CompleteGoogleSignInMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof completeGoogleSignIn>>, TError,CompleteGoogleSignInMutationVariables, TContext> => {

const mutationKey = getCompleteGoogleSignInMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeGoogleSignIn>>, CompleteGoogleSignInMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  completeGoogleSignIn(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteGoogleSignInMutationResult = NonNullable<Awaited<ReturnType<typeof completeGoogleSignIn>>>
    export type CompleteGoogleSignInMutationBody = GoogleComplete
    export type CompleteGoogleSignInMutationError = ErrorType<ErrorEnvelope>
    export type CompleteGoogleSignInMutationVariables = {data: GoogleComplete}

    /**
 * @summary Complete Google Sign In
 */
export const useCompleteGoogleSignIn = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeGoogleSignIn>>, TError,CompleteGoogleSignInMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeGoogleSignIn>>,
        TError,
        CompleteGoogleSignInMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteGoogleSignInMutationOptions(options), queryClient);
    }
    export const getSignOutUrl = () => {




  return `/api/v1/me/sign-out`
}

/**
 * End this browser's session, and clear its media cookies.
 * @summary Sign Out
 */
export const signOut = async ( options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getSignOutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSignOutMutationKey = () => ['signOut'] as const;

export const getSignOutMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext> => {

const mutationKey = getSignOutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOut>>, void> = () => {


          return  signOut(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignOutMutationResult = NonNullable<Awaited<ReturnType<typeof signOut>>>

    export type SignOutMutationError = ErrorType<ErrorEnvelope>


    /**
 * @summary Sign Out
 */
export const useSignOut = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signOut>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSignOutMutationOptions(options), queryClient);
    }
    export const getSignOutEverywhereUrl = () => {




  return `/api/v1/me/sign-out-everywhere`
}

/**
 * End every session of the user, this one included, and clear this browser's media
 * cookies. Personal access tokens stay.
 * @summary Sign Out Everywhere
 */
export const signOutEverywhere = async ( options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getSignOutEverywhereUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSignOutEverywhereMutationKey = () => ['signOutEverywhere'] as const;

export const getSignOutEverywhereMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOutEverywhere>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof signOutEverywhere>>, TError,void, TContext> => {

const mutationKey = getSignOutEverywhereMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOutEverywhere>>, void> = () => {


          return  signOutEverywhere(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignOutEverywhereMutationResult = NonNullable<Awaited<ReturnType<typeof signOutEverywhere>>>

    export type SignOutEverywhereMutationError = ErrorType<ErrorEnvelope>


    /**
 * @summary Sign Out Everywhere
 */
export const useSignOutEverywhere = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOutEverywhere>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signOutEverywhere>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSignOutEverywhereMutationOptions(options), queryClient);
    }
    export const getAcceptTermsUrl = () => {




  return `/api/v1/me/terms/accept`
}

/**
 * Accept the terms in force; 409 `TERMS_VERSION_STALE` for another version.
 * @summary Accept Terms
 */
export const acceptTerms = async (termsAccept: TermsAccept, options?: Parameters<typeof apiRequest>[1]): Promise<Me> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Me>(getAcceptTermsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(termsAccept)
  }
);}





export const getAcceptTermsMutationKey = () => ['acceptTerms'] as const;

export const getAcceptTermsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,AcceptTermsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,AcceptTermsMutationVariables, TContext> => {

const mutationKey = getAcceptTermsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTerms>>, AcceptTermsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  acceptTerms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptTermsMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTerms>>>
    export type AcceptTermsMutationBody = TermsAccept
    export type AcceptTermsMutationError = ErrorType<ErrorEnvelope>
    export type AcceptTermsMutationVariables = {data: TermsAccept}

    /**
 * @summary Accept Terms
 */
export const useAcceptTerms = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,AcceptTermsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptTerms>>,
        TError,
        AcceptTermsMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptTermsMutationOptions(options), queryClient);
    }
    export const getListTokensUrl = () => {




  return `/api/v1/me/tokens`
}

/**
 * The user's live personal access tokens, in every team. Browser sessions only.
 * @summary List Tokens
 */
export const listTokens = async ( options?: Parameters<typeof apiRequest>[1]): Promise<Token[]> => {

  return apiRequest<Token[]>(getListTokensUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTokensQueryKey = () => {
    return [
    `/api/v1/me/tokens`
    ] as const;
    }


export const getListTokensQueryOptions = <TData = Awaited<ReturnType<typeof listTokens>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokens>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTokensQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTokens>>> = ({ signal }) => listTokens({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTokensQueryResult = NonNullable<Awaited<ReturnType<typeof listTokens>>>
export type ListTokensQueryError = ErrorType<ErrorEnvelope>


export function useListTokens<TData = Awaited<ReturnType<typeof listTokens>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTokens>>,
          TError,
          Awaited<ReturnType<typeof listTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTokens<TData = Awaited<ReturnType<typeof listTokens>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTokens>>,
          TError,
          Awaited<ReturnType<typeof listTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTokens<TData = Awaited<ReturnType<typeof listTokens>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokens>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Tokens
 */

export function useListTokens<TData = Awaited<ReturnType<typeof listTokens>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokens>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTokensQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRevokeTokenUrl = (tokenId: string,) => {




  return `/api/v1/me/tokens/${tokenId}`
}

/**
 * Revoke one of the user's tokens; it stops working on its next request.
 * @summary Revoke Token
 */
export const revokeToken = async (tokenId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getRevokeTokenUrl(tokenId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeTokenMutationKey = () => ['revokeToken'] as const;

export const getRevokeTokenMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeToken>>, TError,RevokeTokenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeToken>>, TError,RevokeTokenMutationVariables, TContext> => {

const mutationKey = getRevokeTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeToken>>, RevokeTokenMutationVariables> = (props) => {
          const {tokenId} = props ?? {};

          return  revokeToken(tokenId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeTokenMutationResult = NonNullable<Awaited<ReturnType<typeof revokeToken>>>

    export type RevokeTokenMutationError = ErrorType<ErrorEnvelope>
    export type RevokeTokenMutationVariables = {tokenId: string}

    /**
 * @summary Revoke Token
 */
export const useRevokeToken = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeToken>>, TError,RevokeTokenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeToken>>,
        TError,
        RevokeTokenMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeTokenMutationOptions(options), queryClient);
    }
    export const getApproveOauthRequestUrl = (teamId: string,
    requestId: string,) => {




  return `/api/v1/teams/${teamId}/oauth-requests/${requestId}/approve`
}

/**
 * The person connects the client to this team: a grant and its code, for the client's
 * redirect. A browser session's, with the request's cookie; `write` only if asked.
 * @summary Approve Oauth Request
 */
export const approveOauthRequest = async (teamId: string,
    requestId: string,
    oAuthApproval: OAuthApproval, options?: Parameters<typeof apiRequest>[1]): Promise<OAuthRedirect> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<OAuthRedirect>(getApproveOauthRequestUrl(teamId,requestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(oAuthApproval)
  }
);}





export const getApproveOauthRequestMutationKey = () => ['approveOauthRequest'] as const;

export const getApproveOauthRequestMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOauthRequest>>, TError,ApproveOauthRequestMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveOauthRequest>>, TError,ApproveOauthRequestMutationVariables, TContext> => {

const mutationKey = getApproveOauthRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveOauthRequest>>, ApproveOauthRequestMutationVariables> = (props) => {
          const {teamId,requestId,data} = props ?? {};

          return  approveOauthRequest(teamId,requestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveOauthRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveOauthRequest>>>
    export type ApproveOauthRequestMutationBody = OAuthApproval
    export type ApproveOauthRequestMutationError = ErrorType<ErrorEnvelope>
    export type ApproveOauthRequestMutationVariables = {teamId: string;requestId: string;data: OAuthApproval}

    /**
 * @summary Approve Oauth Request
 */
export const useApproveOauthRequest = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOauthRequest>>, TError,ApproveOauthRequestMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveOauthRequest>>,
        TError,
        ApproveOauthRequestMutationVariables,
        TContext
      > => {
      return useMutation(getApproveOauthRequestMutationOptions(options), queryClient);
    }
    export const getCreateTokenUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/tokens`
}

/**
 * A personal access token for this team, shown once. Browser sessions only.
 * @summary Create Token
 */
export const createToken = async (teamId: string,
    tokenCreate: TokenCreate, options?: Parameters<typeof apiRequest>[1]): Promise<TokenCreated> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<TokenCreated>(getCreateTokenUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tokenCreate)
  }
);}





export const getCreateTokenMutationKey = () => ['createToken'] as const;

export const getCreateTokenMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToken>>, TError,CreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createToken>>, TError,CreateTokenMutationVariables, TContext> => {

const mutationKey = getCreateTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createToken>>, CreateTokenMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  createToken(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTokenMutationResult = NonNullable<Awaited<ReturnType<typeof createToken>>>
    export type CreateTokenMutationBody = TokenCreate
    export type CreateTokenMutationError = ErrorType<ErrorEnvelope>
    export type CreateTokenMutationVariables = {teamId: string;data: TokenCreate}

    /**
 * @summary Create Token
 */
export const useCreateToken = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToken>>, TError,CreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createToken>>,
        TError,
        CreateTokenMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTokenMutationOptions(options), queryClient);
    }
